// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.


export const domainBillingDetailsDto = {
    vatNumber: 'vatNumber',
    billingEmail: 'billingEmail',
} as const;

export type TDomainBillingDetailsDto = (typeof domainBillingDetailsDto)[keyof typeof domainBillingDetailsDto];

export interface IDomainBillingDetailsDto {
    [domainBillingDetailsDto.vatNumber]: string | null;
    [domainBillingDetailsDto.billingEmail]: string | null;
}

export class DomainBillingDetailsDto
    implements IDomainBillingDetailsDto
{
    [domainBillingDetailsDto.vatNumber]: string | null = null;
    [domainBillingDetailsDto.billingEmail]: string | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IDomainBillingDetailsData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[domainBillingDetailsDto.guid] = modelData[domainbillingdetailsData.guid];
    }

    static create(modelData?: any | null): IDomainBillingDetailsDto | null {
        return modelData ? new DomainBillingDetailsDto(modelData) : null;
    }
}
